import { createActionGroup, props } from '@ngrx/store';
import { IntegratedIReckonHotelDto } from '@rocksoft/integrations-ireckon-sdk';
import { ErrorModel } from '@rocksoft/shared';

// ============================================================================
// RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const IReckonIntegratedHotelResolverActions = createActionGroup({
  source: 'IReckon integrated hotel resolver',
  events: {
    'Integration requested': props<{ locationUniqueId: string }>(),
  },
});

// ============================================================================
// API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const IReckonIntegratedHotelApiActions = createActionGroup({
  source: 'IReckon integrated hotel API',
  events: {
    'Integrations loaded': props<{ hotels: IntegratedIReckonHotelDto[] }>(),
    'Integrations loaded error': props<{ error: ErrorModel }>(),
    'Integrations updated': props<{ hotel: IntegratedIReckonHotelDto }>(),
    'Integrations updated error': props<{ hotel: IntegratedIReckonHotelDto; error: ErrorModel }>(),
    'Integrations added': props<{ hotel: IntegratedIReckonHotelDto }>(),
    'Integrations added error': props<{ hotel: IntegratedIReckonHotelDto; error: ErrorModel }>(),
  },
});

// ============================================================================
// VIEW ACTIONS (Group - using createActionGroup)
// ============================================================================

export const IReckonIntegratedHotelContainerActions = createActionGroup({
  source: 'IReckon integrated hotel container',
  events: {
    'Integration updated': props<{ hotel: IntegratedIReckonHotelDto }>(),
  },
});
